



export const questions = [
    {
        "question": "რომელია პროცედურის თვითღირებულების სამი დონე:",
        "correct_answer": "ძირითადი, საწარმოო და სრული თვითღირებულება",
        "incorrect_answers": ["ძირითადი, გეგმური და სრული თვითღირებულება", "ძირითადი, გეგმური და ფაქტიური თვითღირებულება"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "ფინანსური ანგარიშგების შედგენის მიზნებისთვის, პროდუქციის თვითღირებულებაში შემავალი ხარჯებია:",
        "correct_answer": "პირდაპირი ხარჯები და საწარმოო ზედნადები ხარჯები",
        "incorrect_answers": ["პირდაპირი ხარჯები და საერთო-ადმინისტრაციული ხარჯები", "პირდაპირი ხარჯები და არასაწარმოო ზედნადები ხარჯები"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "პროდუქციის სასიცოცხლო ციკლი არის:",
        "correct_answer": "პერიოდი პროდუქტის წარმოების დაწყებიდან მის შეწყვეტამდე",
        "incorrect_answers": ["პერიოდი პროდუქტის წარმოების დაწყებიდან მისი რეალიზაციის მომენტამდე", "პერიოდი პროდუქტის წარმოების ზრდიდან მის დაცემამდე"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "საწარმოს საამქროში პირდაპირი მასალის ხარჯი 14 000 ლარს, პირდაპირი შრომითი ხარჯი 9 300 ლარს, საწარმოო ზედნადები ხარჯები ნორმით 5 000 ლარს, ფაქტიურად 5 300 ლარს და საერთო ადმინისტრაციული ხარჯები 9 800 ლარს შეადგენს. დაუმთავრებელი პროდუქცია არ არსებობს. მზა პროდუქციის თვითღირებულება უდრის (ლარი):",
        "correct_answer": "28 300",
        "incorrect_answers": ["38 100", "18 500"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "პროდუქციის სრული თვითღირებულება გამოიყენაბა:",
        "correct_answer": "პროდუქციის გასაყიდი ფასის დაგეგმვის მიზნებისთვის",
        "incorrect_answers": ["ფინანსური ანგარიშგების შედგენის მიზნებისთვის", "მარაგების შეფასებისთვის"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "სამშენებლო კომპანიის საწყობებში სამშენებლო მასალების მარაგი თვის დასაწყისში 35 000 ლარის იყო. თვის განმავლობაში შესყიდულ იქნა 85 000 ლარის მასალა. თვის ბოლოს საწყობებში 40 000 ლარის მასალა დარჩა. დახარჯული მასალის თვითღირებულება უდრის.",
        "correct_answer": "80 000",
        "incorrect_answers": ["90 000", "50 000"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "მასალის მარაგის ნაშთების ზრდა მზა პროდუქციის თვითღირებულებას:",
        "correct_answer": "ამცირებს",
        "incorrect_answers": ["ზრდის", "არ ცვლის"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "თვის განმავლობაში შესყიდულ იქნა 45 800 ლარის მასალა. თვის ბოლოსთვის მასალის ნაშთი 5 400 ლარით გაიზარდა. დახარჯული მასალის მოცულობა უდრის (ლარი)",
        "correct_answer": "40 400",
        "incorrect_answers": ["51 200", "45 600"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "თვის განმავლობაში შესყიდულ იქნა 62 400 ლარის მასალა. თვის ბოლოსთვის მასალის ნაშთი 7 100 ლარით შემცირდა. დახარჯული მასალები უდრის (ლარი)",
        "correct_answer": "69 500",
        "incorrect_answers": ["55 300", "65 400"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "დაუმთავრებელი პროდუქციის ნაშთების ზრდა მზა პროდუქციის თვითღირებულებას: ",
        "correct_answer": "ამცირებს",
        "incorrect_answers": ["ზრდის", "არ ცვლის"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "საწარმოს საამქროში მიმდინარე თვის წარმოების დანახარჯებმა 47 200 ლარი შეადგინა. დაუმთავრებელი პროდუქციის საწყისი ნაშთი 8500 ლარი და საბოლოო 5100 ლარი იყო. მზა პროდუქციის თვითღირებულება უდრის (ლარი):",
        "correct_answer": "50 600",
        "incorrect_answers": ["43 800", "45 500"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "მზა პროდუქციის ნაშთების შემცირება რეალიზებული პროდუქციის თვითღირებულებას: ",
        "correct_answer": "ზრდის",
        "incorrect_answers": ["ამცირებს", "არ ცვლის"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "მიმდინარე თვეში 45 000 ლარის თვითღირებულების პროდუქცია იქნა გამოშვებული. მზა პროდუქციის ნაშთი თვის ბოლოსთვის 3 200 ლარით გაიზარდა.  რეალიზებული პროდუქციის თვითღირებულება უდრის (ლარი): ",
        "correct_answer": "41 800",
        "incorrect_answers": ["48 200", "50 300"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "პროდუქციის ფასნამატი არის : ",
        "correct_answer": "რეალიზაციიდან მიღებული მოგების ფარდობა მის სრულ თვითღირებულებასთან",
        "incorrect_answers": ["რეალიზაციიდან მიღებული მოგების ფარდობა რეალიზაციიდან მიღებულ შემოსავალთან", "რეალიზებული პროდუქციის სრული თვითღირებულების ფარდობა მოგებასთან"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "პროდუქციის მოგების მარჟა არის : ",
        "correct_answer": "რეალიზაციიდან მიღებული მოგების ფარდობა რეალიზაციიდან მიღებულ შემოსავალთან ",
        "incorrect_answers": ["რეალიზაციიდან მიღებული მოგების ფარდობა მის სრულ თვითღირებულებასთან", "რეალიზებული პროდუქციის სრული თვითღირებულების ფარდობა მოგებასთან"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "პროდუქციის ერთეულზე პირდაპირი მასალის ხარჯი 22 ლარი, პირდაპირი შრომითი ხარჯი 18 ლარი, საწარმოო ზედნადები ხარჯები ნორმით 10 ლარი, მარკეტინგის ხარჯები 3 ლარიი, მარკეტინგის ხარჯები 5 ლარი, საპროცენტო ხარჯი 2 ლარია. ფასნამატი დადგენილია 20%. ერთი ცალი პროდუქტის გასაყიდი ფასი იქნება (ლარი)",
        "correct_answer": "69,6",
        "incorrect_answers": ["72,0", "75,2"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "მზა პროდუქცია სარეალიზაციო ფასით შეადგენს 75 600 ლარს. ფასნამატი დადგენილია 25%. მზა პროდუქციის სრული თვითღირებულება უდრის (ლარი)",
        "correct_answer": "60 480",
        "incorrect_answers": ["56 700", "50 200"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "მზა პროდუქცია სრული თვითღირებულებით 85 500 და სარეალიზაციო ფასით 100 890 ლარია. ფასნამატი უდრის: ",
        "correct_answer": "18.00 %",
        "incorrect_answers": ["15,25 %", "20,22 %"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "მზა პროდუქცია სრული თვითღირებულებით 45 700 ლარი და სარეალიზაციო ფასით 57 125 ლარია. მარჟა უდრის: ",
        "correct_answer": "20 %",
        "incorrect_answers": ["25 %", "18 %"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "მზა პროდუქცია სარეალიზაციო ფასით 80 000 ლარია. დადგენილია მოგების მარჟა 20% და ფასნამატი 25 %. მოგება უდრის (ლარი)",
        "correct_answer": "16 000",
        "incorrect_answers": ["20 000", "24 000"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "თვის ბოლოს წარმოებაში დაუმთავრებელი დარჩა 800 ცალი პროდუქტი, რომლის ყოველი ერთეული საშუალოდ 60%-ითაა დამთავრებული. რას უდრის დაუმთავრებელი პროდუქცია მზა პროდუქციის ეკვივალენტურ ერთეულებში: ",
        "correct_answer": "480 ეკვ ერთ.",
        "incorrect_answers": ["500 ეკვ. ერთ", "700 ეკვ. ერთ"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "არსებობს პროდუქციის წარმოების დანახარჯების შემდეგი ინფორმაცია: პირდაპირი მასალის ხარჯი 16 700,  პირდაპირი შრომითი ხარჯი 14 800, საწარმოო ზედნადები ხარჯები ფაქტიურად 9 500, საწარმოო ზედნადები ხარჯები ნორმით 9 000, დაუმთავრებელი პროდუქციის ნაშთების ზრდა 3 600,  მზა პროდუქციის ნაშთების ზრდა 3 600, მზა პროდუქციის ნაშთების შემცირება 4 300, რეალიზებული პროდუქციის თვითღირებულება უდრის:  ",
        "correct_answer": "41 200",
        "incorrect_answers": ["39 800", "41 700"],
        "unit": "4",
        "type": "task"
    },
    {
        "question": "მოცემული ჩამონათვალიდან რომელია პროდუქციის თვითღირებულების კალკულაციის მეთოდი:",
        "correct_answer": "კალკულაცია შეკვეთების მიხედვით",
        "incorrect_answers": ["კალკულაცია ზღვრული დანახარჯებით", "კალკულაცია ალტერნატიული დანახარჯებით"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "პროდუქციის თვითღრირებულების კალკულაციის პრინციპებია: ",
        "correct_answer": "კალკულაცია ზღვრული და სრული დანახარჯებით",
        "incorrect_answers": ["კალკულაცია პროდუქციის პარტიების და კონტრაქტების მიხედვით", "კალკულაცია ნორმატიული და გეგმური დანახარჯებით"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "პროდუქციის თვითღირებულების ნორმატიული კალკულაცია წარმოადგენს: ",
        "correct_answer": "კალკულაციის ტექნიკას",
        "incorrect_answers": ["კალკულაციის მეთოდი", "კალკულაციის პრინციპს"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "პროდუქციის წარმოების პირდაპირი დანახარჯები აღირიცხება: ",
        "correct_answer": "დაუმთავრებელი წარმოების (პროდუქციის) ანგარიშის დებეტში",
        "incorrect_answers": ["მზა პროდუქციის ანგარიშის კრედიტში", "მოგება/ზარალის ანგარიშის დებეტში"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "ფაქტიური საწარმოო ზედნადები ხარჯები აღირიცხება: ",
        "correct_answer": "საწარმოო ზედნადები ხარჯების ანგარიშის დებეტში",
        "incorrect_answers": ["დაუმთავრებელი წარმოების ანგარიშის დებეტში", "მოგება/ზარალის ანგარიშის დებეტში"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "გეგმური ნორმატივით მიკუთვნებული საწარმოო ზედნადები ხარჯები აღირიცხება: ",
        "correct_answer": "საწარმოო ზედნადები ხარჯების ანგარიშის დებეტში",
        "incorrect_answers": ["დაუმთავრებელი წარმოების ანგარიშის დებეტში", "მოგება/ზარალის ანგარიშის დებეტში"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "საწარმოო ზედნადები ხარჯების მიკუთვნების სხვაობა დაეწერება: ",
        "correct_answer": "მოგება/ზარალის ანგარიშს",
        "incorrect_answers": ["მზა პროდუქციის ანგარიშს", "დაუმთავრებელი პროდუქციის ანგარიშს"],
        "unit": "4",
        "type": "theory"
    },
    {
        "question": "ნახევრადცვლადი დანახარჯებიდან მუდმივი ხარჯების გამოყოფა ხდება: ",
        "correct_answer": "მინიმუმისა და მაქსიმუმის მეთოდების გამოყენებით",
        "incorrect_answers": ["წარმოების წაუგებლობის ანალიზით", "ზღვრული დანახარჯების კალკულაციის მეთოდით"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "მინი-მაქსის მეთოდით ცვლადი ხარჯი პროდუქციის ერთეულზე გამოითვლება: ",
        "correct_answer": "მაქსიმალურ და მინიმალურ დანახარჯებს შორის სხვაობის შეფარდებით წარმოების დონეებს შორის სხვაობაზე",
        "incorrect_answers": ["წარმოების დონეებს შორის სხვაობის გამრავლებით წარმოების მინიმუმზე", "მუდმივ და ცვლად ხარჯებს შორის სხვაობის გამრავლებით წარმოების მაქსიმუმზე"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "მოცემულია ფირმის საწარმოო განყოფილების ორი დონე: პროდუქციის გამოშვება (ცალი) 15 000 და 19 500, ნახევრად ცვლადი ხარჯები შესაბამისად 46 100 და 57 350. ცვლადი ხარჯი პროდუქციის ერთეულზე უდრის (ლარი)",
        "correct_answer": "2,5",
        "incorrect_answers": ["3", "4"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "ფირმა ერთი სახის პროდუქტს აწარმოებს. მთლიანი ხარჯები 3200 ცალი პროდუქტის წარმოებისას 25 060 ლარს, ხოლო 6000 ცალის წარმოებისას 38 500 ლარს შეადგენს. მუდმივი ხარჯები უდრის (ლარი) ",
        "correct_answer": "9 700",
        "incorrect_answers": ["13 440", "6 000"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "პროდუქციის გეგმური გამოშვება 7 200 ერთეულს შეადგენს. გეგმით ცვლადი ხარჯი პროდუქციის ერთეულზე 9.5 ლარია. მუდმივი ხარჯები სულ 16 000 ლარი დაიგეგმა. პროდუქციის წარმოების მთლიანი გეგმური ხარჯები იქნება (ლარი) ",
        "correct_answer": "84 400",
        "incorrect_answers": ["68 400", "52 000"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "პროდუქციის წარმოების მთლიანი ხარჯები ფაქტიურად შეადგენს 80 000 ლარს. მთლიანი მუდმივი ხარჯები 14 000 ლარი და ცვლადი ხარჯი პროდუქციის ერთეულზე 5 ლარია. გამოშვებული პროდუქციის რაოდენობა უდრის (ცალი)",
        "correct_answer": "13 200",
        "incorrect_answers": ["12 000", "16 000"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "3200 ცალი პროდუქტის წარმოების ხარჯები 25 000 ლარია. ცვლადი ხარჯი პროდუქციი ერთეულზე 5 ლარი. რამდენი ცალი პროდუქტი იქნება გამოშვებული, თუ წარმოების მთლიანი ხარჯები 20%-ით შემცირდება, ხოლო მთლიანი მუდმივი ხარჯები იგივე დარჩება (ცალი) ",
        "correct_answer": "2 200",
        "incorrect_answers": ["1 800", "4 000"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "ზღვრული მოგება გამოითვლება: ",
        "correct_answer": "შემოსავალს რეალიზაციიდან მინუს ცვლადი ხარჯები",
        "incorrect_answers": ["რეალიზაციიდან მიღებულ შემოსავალს მინუს რეალიზაციის თვითღირებულება", "შემოსავალს რეალიზაციიდან მინუს მუდმივი ხარჯები"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "მთლიანი ზღვრული მოგება არის: ",
        "correct_answer": "მოგებისა და მუდმივი ხარჯების ჯამი",
        "incorrect_answers": ["მოგებისა და თვითღირებულების ჯამი", "ცვლადი ხარჯებისა და მუდმივი ხარჯების სხვაობა"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "წარმოების წონასწორობის წერტილში: ",
        "correct_answer": "მთლიანი ხარჯები უდრის შემოსავლებს",
        "incorrect_answers": ["მუდმივი ხარჯები უდრის ცვლად ხარჯებს", "მოგება უდრის ზღვრულ მოგებას"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "რომელი თვალსაზრისია არასწორი: ",
        "correct_answer": "წაუგებლობის წერტილში ზღვრული მოგება უდრის მუდმივ ხარჯებს",
        "incorrect_answers": ["წაუგებლობის წერტილში მოგება უდრის მუდმივ ხარჯებს", "წაუგებლობის წერტილში მოგება უდრის ზღვრული მოგებისა და მუდმივი ხარჯების სხვაობას"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "წარმოების წაუგებლობის (ანუ წონასწორობის) წერტილი აჩვენებს: ",
        "correct_answer": "პროდუქციის იმ რაოდენობას, როცა არც ზარალია და არც მოგება",
        "incorrect_answers": ["პროდუქციის იმ რაოდენობას, როცა მოგება მეტია ზღვრულ მოგებაზე", "პროდუქციის იმ რაოდენობას, როცა მოგება უდრის ზღვრულ მოგებას"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "არსებობს ფირმის საწარმოო განყოფილების შემდეგი ინფორმაცია: მიმდინარე თვეში გამოშვებულ იქნა 800 ცალი პროდუქტი, რომლის გასაყიდი ფასი 10 ლარი და ცვლადი ხარჯი ერთ ერთეულზე 8 ლარია. მთლიანი ზღვრული მოგება უდრის (ლარი)",
        "correct_answer": "1 600",
        "incorrect_answers": ["6 400", "8 000"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "საწარმო უშვებს პროდუქტს, რომლის ერთეულის გასაყიდი ფასი 15 ლარი და ცვლადი ხარჯი 10 ლარია. მთლიანი მუდმივი ხარჯები 900 ლარია. რამმდენი ცალი პროდუქტი უნდა გაიყიდოს წონასწორობის წერტილის მისაღწევად:",
        "correct_answer": "180",
        "incorrect_answers": ["100", "60"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "გამოსაშვები პროდუქციის ერთეულის ფასი 12 ლარი და ცვლადი ხარჯი 8 ლარია. მუდმივი ხარჯები 1 400 ლარია. რამდენი ცალი პროდუქტი უნდა გაიყიდოს 5 000 ლარი მოგების მისაღწევად",
        "correct_answer": "1 600",
        "incorrect_answers": ["625", "1 250"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "კომპანია 2 000 ცალი პროდუქტის წარმოებას გეგმავს. ცვლადი ხარჯი პროდუქციის ერთეულზე 14 ლარია. მუდმივი ხარჯები 7 600 ლარს შეადგენს. თუ ცვლადი ხარჯი პროდუქციის ერთეულზე 10%-ით გაიზრდება, რამდენი უნდა იყოს ერთეულის გასაყიდი ფასი, რათა მიღებულ იქნას 6 000 ლარის მოგება.",
        "correct_answer": "22.22",
        "incorrect_answers": ["23", "21.8"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "წარმოების უსაფრთხოების დიაპაზონი უდრის:",
        "correct_answer": "რეალიზაციის გეგმურ რაოდენობას მინუს პროდუქციის რაოდენობა წონასწორობის წერტილში",
        "incorrect_answers": ["პროდუქციის ფაქტიურ რაოდენობას მინუს პროდუქციის რაოდენობა წონასწორობის წერტილში", "პროდუქციის რაოდენობას წონასწორობის წერტილში მინუს პროდუქციის დაგეგმილი რაოდენობა"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "გააკეთეთ შესაბამისი დასკვნა როცა წარმოების უსაფრთხოების დიაპაზონი 1 500 ერთეულს უდრის. მაშინ: ",
        "correct_answer": "პროდუქციის გეგმური გამოშვება ფაქტიურად შეიძლება მაქსიმუმ 1 500 ერთეულით დაეცეს",
        "incorrect_answers": ["პროდუქციის გეგმური გამოშვება ფაქტიურად შეიძლება მაქსიმუმ 1 500 ერთეულით გაიზარდოს", "ნულოვანი წარმოებიდან წონასწორობის წერტილამდე 1 500 ერთეულია"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "წონასწორობის (იგივე წაუგებლობის) სტანდარტული გრაფიკი აიგება მაშინ, როცა დაცულია შემდეგი ძირითადი დაშვებები ",
        "correct_answer": "პროდუქციის ერთეულზე ცვლადი ხარჯი, გასაყიდი ფასი და ზღვრული მოგება მუდმივია, მთლიანი მუდმივი ხარჯები უცვლელია",
        "incorrect_answers": ["პროდუქციის ერთეულის გასაყიდი ფასი და ცვლადი ხარჯი ერთეულზე იცვლება, მთლიანი მუდმივი ხარჯი უცვლელია", "პროდუქციის ერთეულზე გასაყიდი ფასი, ცვლადი ხარჯი და ზღვრუკლი მოგება მუდმივია, მუდმივი ხარჯი მთლიანობაში არ იცვლება"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "რომელი თვალსაზრისია სწორი: წონასწორობის წერტილი რეალიზაციის მოცულობაში უდრის:",
        "correct_answer": "მუდმივი ხარჯებისა და შემოსავლების ნამრავლის ფარდობას ზღვრულ მოგებასთან",
        "incorrect_answers": ["მუდმივი ხარჯების ფარდობას შემოსავლებთან", "შემოსავლების ფარდობას მუდმივი ხარჯებისა და ზღვრული მოგების ნამრავლთან"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "ლუდის ქარხანამ გეგმით 25 000 პირობითი ბოთლი ლუდი უნდა გაყიდოს. პროდუქციის რაოდენობა წონასწორობის წერტილში 12 000 პირობითი ბოთლია. რომელი თვალსაზრისია არასწორი:",
        "correct_answer": "თუ ლუდის გაყიდვები გეგმურთან შედარებით 13 500 პ/ბოთლით შემცირდება, ქარხანა მაინც მომგებიანი იქნება",
        "incorrect_answers": ["ქარხანა 12 000 პირობითი ბოთლის გაყიდვის შემდეგ დაიწყებს მოგების მიღებას", "თუ ლუდის გაყიდვები გეგმურთან შედარებით 12 500 პ/ბოთლით შემცირდება, ქარხანა მაინც მომგებიანი იქნება."],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "საწარმომ მიმდინარე თვეში გეგმით 3 000 ცალი პროდუქტი უნდა გამოუშვას. მუდმივი ხარჯები 4 200 ლარს, ხოლო ზღვრული მოგება პროდუქციის ერთეულზე 3 ლარს შეადგენს. წარმოების უსაფრთხოების დიაპაზონი იქნება (ცალი)",
        "correct_answer": "1 600",
        "incorrect_answers": ["1 400", "1 200"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "სამრეწველო კომპანიის ზღვრული მოგება და შემოსავლების ფარდობის კოეფიციენტი არის 0,35. მუდმივი ხარჯები 17 000 ლარს შეადგენს.წონასწორობის წერტილი რეალიზაციის მოცულობაში უდრის (ლარი)",
        "correct_answer": "48 571",
        "incorrect_answers": ["50 602", "52 700"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "ზღვრული მოგებისა და შემოსავლების ფარდობის კოეფიციქნტი (ც / ს) არის 0,45. შემოსავალი რეალიზაციიდან 55 000 ლარია. ზღვრული მოგება უდრის (ლარი)",
        "correct_answer": "24 750",
        "incorrect_answers": ["23 700", "16 800"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "კომპანიის საწარმოო გეგმით დადგენილია კოეფიციენტები: c/s = 0,45; p/s = 0,30. ფირმის გეგმური მოგება 15 000 ლარია. ზღვრული მოგება იქნება (ლარი)",
        "correct_answer": "22 500",
        "incorrect_answers": ["14 500", "16 750"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "წარმოების წაუგებლობის სტანდარტულ გრაფიკზე წონასწორობის წერტილი იმყოფება:",
        "correct_answer": "მთლიანი ხარჯებისა და შემოსავლების გრაფიკების გადაკვეთის წერტილში",
        "incorrect_answers": ["ცვლადი ხარჯებისა და მუდმივი ხარჯების გრაფიკების გადაკვეთის წერტილში", "მთლიანი ხარჯებისა და შემოსავლების გრაფიკების გადაკვეთის წერტილში"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "მთლიანი ზღვრული მოგების ზრდას ყველაზე მეტად გამოიწვევს:",
        "correct_answer": "სარეალიზაციო ფასის 10%-ით ზრდა",
        "incorrect_answers": ["ცვლადი ხარჯების 10%-ით შემცირება", "მუდმივი ხარჯების 20%-ით შემცირება"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "ფირმის გეგმური უსაფრთხოების დიაპაზონი 20%-ია. გეგმური რეალიზაცია 7400 ერთეული. ზღვრული მოგება პროდუქტის ერთეულზე 15 ლარია. გეგმური მუდმივი დანახარჯები იქნება (ლარი)",
        "correct_answer": "88 800",
        "incorrect_answers": ["59 200", "60 800"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "სამშენებლო ფირმაში არსებული მონაცემებით, შემოსავალი რეალიზაციიდან შეადგენს 60 000 ლარს. c/ს = 0,40 და c/ს = 0,30. მუდმივი ხარჯები უდრის (ლარი)",
        "correct_answer": "6 000",
        "incorrect_answers": ["24 000", "18 000"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "კომპანია გეგმავს 'ა' პროდუქტის გამოშვებას, რომელსაც წლიურად 45 000 მანქანა/სთ და 60 000 კგ ნედლეული სჭირდება. აღმოჩნდა, რომ კომპანიის სიმძლავრეებს შეუძლიათ გამოიმუშაონ 41 000 მანქანა/სთ და წლიურად შეიძლება შეისყიდონ და გადაამუშაონ 65 000 კგ ნედლეული. რომელი თვალსაზრისია სწორი:",
        "correct_answer": "მანქანა დანადგარების სიმძლავრე წარმოადგენს წარმოების შემზღუდველ ფაქტორს.",
        "incorrect_answers": ["ნედლეულის მარაგი წარმოადგენს წარმოების შემზღუდველ ფაქტორს", "ფულადი თანხების დეფიციტი წარმოადგენს წარმოების შემზღუდველ ფაქტორს"],
        "unit": "3",
        "type": "theory"
    },
    {
        "question": "ფირმა აწარმოებს ერთი სახის პროდუქტს, რომლის ერთეულის ცვლადი ხარჯია 35ლ და ზღვრული მოგების რეალიზაციასთან ფარდობის კოეფიციენტია 0,30. მთლიანი თვის მუდმივი დანახარჯები 63 900 ლარია. წაუგებლობის წერტილი მოცემულ თვეში უდრის (ერთეული):",
        "correct_answer": "4 260",
        "incorrect_answers": ["5 320", "19 170"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "ფირმა აწარმოებს ერთი სახის პროდუქტს, რომლის ერთეულის გასაყიდი ფასია 20 ლარი. რეალიზაციასთან მოგების ფარდობის კოეფიციენტია 0,40. წაუგებლობის წერტილი რეალიზაციის მოცულობაში 26 000 ლარია თვეში. რამდენი ლარი იქნება მოგება, როცა 2 000 ერთეული გაიყიდება (ლარი)",
        "correct_answer": "16 000",
        "incorrect_answers": ["9 400", "5 600"],
        "unit": "3",
        "type": "task"
    },
    {
        "question": "პირდაპირი მასალის ხარჯი ისეთი ხარჯია, რომელიც: ",
        "correct_answer": "გაწევის მომენტში ცნობილია რომელი სახის პროდუქციის წარმოებაზე იხარჯება და ამიტომ, პირდაპირ, განაწილების გარეშე მიეკუთვნებაცალკეული სახის პროდუქციის თვითღირებულებას",
        "incorrect_answers": ["გაწევის მომენტში ცნობილი არაა რომელი სახის პროდუქციაზე იხარჯება და ამიტომ, განაწილების გარეშე მიეკუთვნება ცალკეული სახის პროდუქციის თვითღირებულებას", "გაწევის მომენტში ცნობილია რომელი სახის პროდუქციის წარმოებაზე იხარჯება და ამიტომ განაწილების გზით მიეკუთვნება ცალკეული სახის პროდუქციის თვითღირებულებას"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "რა მიზნით და ვის მიერ გამოიწერება დოკუმენტი - 'მოთხოვნა შეკვეთაზე'. ",
        "correct_answer": "საწყობის მენეჯერი აგზავნის შესყიდვების განყოფილებაში, რათა განათავსონ შეკვეთა მასალაზე",
        "incorrect_answers": ["წარმოების მენეჯერის მიერ იგზავნება მასალის საწყობში, მასალების გაცემაზე", "შესყიდვების განყოფილება აგზავნის მომწოდებელთან მასალის მოწოდებაზე."],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "რა მიზნით და ვის მიერ გამოიწერება დოკუმენტი - 'შეკვეთა შესყიდვაზე' ",
        "correct_answer": "შესყიდვების განყოფილება აგზავნის მომწოდებელთან მასალის მოწოდებაზე",
        "incorrect_answers": ["საწყობის მენეჯერი აგზავნის მომწოდებელთან მასალის მოწოდებაზე", "წარმოების მენეჯერი აგზავნის შესყიდვების განყოფილებაში შეკვეთის განთავსებაზე"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "როდის და ვის მიერ ფორმდება დოკუმენტი - 'მასალის მიღების ორდერი' ",
        "correct_answer": "საწყობის მენეჯერის მიერ, მასალების მიღების დროს",
        "incorrect_answers": ["შესყიდვების განყოფილების მიერ მასალის მიღების დროს", "საფინანსო განყოფილების მენეჯერის მიერ მასალების შესყიდვის დროს"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "დოკუმენტი: 'შესყიდვის ანგარიშ-ფაქტურა' - არის: ",
        "correct_answer": "მასალის მომწოდებლიდან მიღებული დოკუმენტი",
        "incorrect_answers": ["შესყიდვების განყოფილებიდან საწყობში მიღებული დოკუმენტი", "წარმოების მენეკერის მიერ გამოწერილი დოკუმენტი მასალის შესყიდვაზე"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "დოკუმენტი: 'შესყიდვის ანგარიშ-ფაქტურა' - არის: ",
        "correct_answer": "მასალის მომწოდებლიდან მიღებული დოკუმენტი",
        "incorrect_answers": ["შესყიდვების განყოფილებიდან საწყობში მიღებული დოკუმენტი", "წარმოების მენეკერის მიერ გამოწერილი დოკუმენტი მასალის შესყიდვაზე"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "ვის მიერ და რა მიზნით გამოიწერება დოკუმენტი - 'მოთხოვნა მასალის გაცემაზე'",
        "correct_answer": "წარმოების მენეჯერი აგზავნის საწყობში, მასალის გაცემაზე",
        "incorrect_answers": ["შესყიდვების განყოფილება აგზავნის საწყობში, მასალის გაცემაზე", "საწყობის მენეჯერი აგზავნის გაყიდვების განყოფილებაში, მასალის მოწოდებაზე"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "რა მიზნით გამოიყენება 'მასალის მარაგის სააღრიცხვო წიგნი'",
        "correct_answer": "მასში თითოეული სახის მასალა აღიარება ცალკე ბარათზე, რომელშც ასახულია მასალის მიღება, გაცემა და ნაშთი რაოდენობრივად და თანხობრივად",
        "incorrect_answers": ["მასში ცალკეული სახის ძირითადი საშუალებები აღირიცხება ცალკე ბარათზე, რაოდენობრივად და თანხობრივად", "მასში თითოეული სახის მზა პროდუქცია აღირიცხება ცალკე ბარათზე, რაოდენობრივად და თანხობრივად."],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "შესყიდული მასალების თვითღირებულებაშ შედის:",
        "correct_answer": "მომწოდებლის ფასი, ტრანსპორტირების ხარჯები, საბაჟო გადასახადი",
        "incorrect_answers": ["მომწოდებლის ფასი, ტრანსპორტირების ხარჯები, დღგ და ფასდათმობა", "მომწოდებლის ფასი, ტრანსპორტირების ხარჯები, აქციზი, საბაჟო გადასახადი"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "დახარჯული მასალების შეფასების რომელი მეთოდია ცნობილი:",
        "correct_answer": "საშუალო შეწონილი თვითღირებულება, ინდივიდუქლური თვითღირებულება, FIFO, LIFO, NIFO, ნორმატიული თვითღირებულება",
        "incorrect_answers": ["ინდივიდუალური თვითღრებულება, FIFO და LIFO", "ინდივიდუალური თვითღირებულება, ნორმატიული თვითღირებულება, თეორიული თვითღირებულება"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "რომელ კონცაფციას ეყრდნობა დახარჯული მასალების შეფასების FIFO მეთოდი",
        "correct_answer": "პირველად იხარჯება ყველაზე ადრე შეძენილი მასალები",
        "incorrect_answers": ["პირველად იხარჯება ყველაზე ბოლოს შეძენილი მასალები", "მასალების შეძენის დროს ყურადღება არ ექცევა"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "რომელი თვალსაზრისია სწორი:",
        "correct_answer": "NIFO მეთოდით, საწყობიდან გაცებული მასალების თვითღირებულება ფასდება მასალის მომავალი შეძენის ფასით",
        "incorrect_answers": ["LIFO მეთოდით, საწყობში დარჩენილი მასალის ნაშთის ვითღირებულება ფასდება ყველაზე ადრე შეძენილი მასალის ფასით", "FIFO მეთოდით, საწყობში დარჩენილი მასალის ნაშთის თვითღრებულება ფასდება ბოლოს შეძენილი მასალის ფასით"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "სამრეწველო ფირმაში, შესყიდვების გეგმით გათვალისწინებულია, რომ მასალის ერთეულის შესყიდვა მოხდება: 2 იანვრიდან - 5ლ/კგ, 10 იანვრიდან - 5,5 ლ/კგ, 20 იანვრიდან - 5,6 ლ/კგ. 5 იანვარს კი მოხდა 400 კგ მასალის გაცემა საწყობიდან.",
        "correct_answer": "2 200",
        "incorrect_answers": ["2 000", "2 240"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "რომელი თვალსაზრისია სწორი: ",
        "correct_answer": "მასალის მარაგის შეფასების მეთოდები ცვლიან საწარმოს მოგებას",
        "incorrect_answers": ["მასალის მარაგის შეფასების მეთოდები გავლენას არ ახდენენ მოგების მაჩვენებელზე", "მასალის შეფასების მეთოდები ზრდიან საწარმოს მოგებას"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "მასალის მარაგის შენახვის წლიური ხარჯი ტოლია: ",
        "correct_answer": "საშუალო მარაგი გამრავლებული მასალის ერთეულის შენახვის საშუალო წლიურ ხარჯზე",
        "incorrect_answers": ["საშუალო მარაგი გამრავლებული შეკვეთის წლიურ რიცხვზე", "შეკვეთის წლიური რიცხვი გამრავლებული მასალის ერთეულის შენახვის საშალო წლიურ ხარჯზე"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "მასალაზე შეკვეთის განთავსების წლიური ხარჯი ტოლია:",
        "correct_answer": "ერთი შეკვეთის განთავსების ხარჯი გამრავლებული შეკვეთის წლიურ რიცხვზე",
        "incorrect_answers": ["მასალის ერთეულის შენახვის საშალო წლიური ხარჯი გამრავლებული შეკვეთის რიცხვზე", "ერთი შეკვეთის განთავსების ხარჯი გამრავლებული მასალის საშუალო მარაგზე"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "მასალის შეკვეთის წერტილი ანუ განმეორებითი შეკვეთის დონე ახასიათებს: ",
        "correct_answer": "მარაგის დონეს საწყობში, როცა უნდა განმეორდეს შეკვეთა",
        "incorrect_answers": ["რამდენი უნდა იყოს საწყობების ფართობი", "რამდენია მასალის შენახვის მინიმალური ხარჯები"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "მასალის მინიმალური მარაგი ახასიათებს: ",
        "correct_answer": "დონეს, რომლის დაბლა მარაგი საწყობში არ უნდა დაეცეს",
        "incorrect_answers": ["მასალის გარდაუვალ ხარჯებს", "დონეს, რომლის მაღლა მარაგი საწყობში არ უნდა ავიდეს"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "მასალის მაქსიმალური მარაგი ახასიათებს",
        "correct_answer": "დონეს, რომელსაც მასალის მარაგი საწყობებში არასოდეს გადააჭარბებს",
        "incorrect_answers": ["დონეს, რომლის დაბლაც საწყობში მარაგის სიდიდე არ უნდა დაეცეს", "ბუფერული მარაგის სიდიდეს"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "მასალის შეკვეთის ოპტიმალური მოცულობა ისეთი სიდიდეა: ",
        "correct_answer": "როცა შეკვეთის განთავსებისა და მარაგის შენახვის ხარჯებისმინიმალურია",
        "incorrect_answers": ["როცა შეკვეთის განთავსების ხარჯები აღემატება მარაგის შენახვის ხარჯებს", "როცა შეკვეთის განთავსების ხარჯები ნაკლებია მარაგის შენახვის ხარჯებზე"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "სამრეწველო ფირმის ინფორმაციით, მასალის დღიური მოხამრება 180 - 200 კილოგრამია. მასალის შეძენას 10 - 12 დღე სჭირდება. შეკვეთის წერტილი უდრის (კგ):",
        "correct_answer": "2 400",
        "incorrect_answers": ["1 800", "2000"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "არსებობს შემდეგი ინფორმაცია: მასალაზე დღიური მოთხოვნა 260 - 300 კგ და მასალის მოწოდების დღეთა რიცხვი 12 -14 დღეა. მინიმალური (სარეზერვო) მარაგი იქნება (კგ):",
        "correct_answer": "560",
        "incorrect_answers": ["360", "1 080"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "სამშენებლო ფირმაშ X მასალაზე წლიური მოთხოვნაა 72 250 ტ. ერთი ტონა მასალის შენახვის საშალო წლიური ხარჯია 20 ლ და ერთი შეკვეთის განთავსებას 25 ლარი სჭირდება. შეკვეთის ოპტიმალიური მოცულობა უდრის (ტონა):",
        "correct_answer": "425",
        "incorrect_answers": ["500", "825"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "სამრეწველო კომპანიას წელიწადში 38 000 ტ X მასალა სჭირდება. შეკვეთის ოპტიმალური მოცულოაა 1 520 ტ. ერთი შეკვეთის შესრულებას 20 ლ სჭირდება. შეკვეთის რიცხვი წელიწადშ უდრის: ",
        "correct_answer": "25",
        "incorrect_answers": ["20", "30"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "საწარმოს ინფორმაციით, მასალაზე შეკვეთის ოპტიმალური მოცულობაა 2 500 კგ. შესყიდვის ფასია 16 ლ/კგ. 1კგ მასალის შენახვის საშუალო წლიური ხარჯი მისი შესყიდვის ფასის 25%-ია და ირთი შეკვეთის განთავსებას 22 ლარი სჭირდება. მარაგის შენახვის წლიური ხარჯი უდრის (ლარი):",
        "correct_answer": "5 000",
        "incorrect_answers": ["10 000", "8 000"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "მასალის მარაგის ერთეულის შენახვის წლიური ხარჯის ზრდა რა გავლენას მოახდენს შეკვეთის ოპტიმალურ მოცულობაზე",
        "correct_answer": "გაზრდის",
        "incorrect_answers": ["შეამცირებს", "გავლენას არ მოახდენს"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "კომპანიაში ერთი თვის მანძილზე ადგილი ჰქონდა შემდეგ ოპერაციებს: მასალის ხარჯი - 200, მომწოდებლისთვის დაბრუნებული მასალები - 2, წარმოებაზე მასალის გაცემა - 180, წარმოებიდან მასალის დაბრუნება საწყობში - 3, უვარგისი მასალების ჩამოწერა - 1, მასალის დანაკლისი - 4 (რიცხვები ათას ლარში). მასალის ნაშთი თვის დასაწყისშ 15 ათას ლარს შეადგენდა. მასალის ანგარიშის ნაშთი თვის ბოლოს იქნება (ათასი ლარი)",
        "correct_answer": "31",
        "incorrect_answers": ["28", "25"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "მასალების პერიოდული აღრიცხვის მეთოდის დროს: ",
        "correct_answer": "მასალების შესყიდვა დანახარჯებში აღირიცხება",
        "incorrect_answers": ["მასალების შესყიდვა და გაცემა მასალის ანგარიშზე აღირიცხება.", "მასალების შესყიდვა და გაცემა მოგება/ზარალის ანგარიშზე აღირიცხება"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "რომელი თვალსაზრისია სწორი: ",
        "correct_answer": "მასალის უწყვეტი აღრიცხვის დროს მასალის ნაშთი გამოითვლება მასალის ანგარიშზე",
        "incorrect_answers": ["მასალების პერიოდული აღრიცხვის დროს მასალების ნაშთი გამოითვლება მასლების ანგარიშზე", "მასალის უწყვეტი აღრიცხვის დროს მასალების შეძენა და გაცემა არ აღირიცხება ანგარიშზე"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "კომპანია წლიურად 8 000 ტ მასალას მოიხმარს. მასალის შესყიდვის ფასია 50 ლ/ტ. თუ ერთ შეკვეთაზე 155 ტონას შეუკვეთავენ, კომპანიის გაანგარიშებით, შეკვეთების განთავსებისა და მასალის შენახვის წლიური ხარჯები სულ 1 560 ლარი იქნება. თუკი ერთი შეკვეთის მოცულობა 200 ტ იქნება, მაშინ მომწოდებელი სთავაზობს 5%-იან ფასდათმობას, ხოლო მარაგის შენახვისა და შეკვეთების განთავსების წლიური ხარჯი სულ 2 600 ლარი იქნება. როგორ შეიცვლება კომპანიის მთლიანი დანახარჯი 200 ტონა მოცულობის შეკვეთაზე გადასვლის დროს: ",
        "correct_answer": "დანაზოგი 18 960",
        "incorrect_answers": ["დამატებითი ხარჯი 18 960", "არ შეიცვლება"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "პროდუქციის წარმოებაზე გაწეული პირდაპირი მასალის ხარჯები აღირიცხება: ",
        "correct_answer": "დებეტი - დაუმთავრებელი წარმოება, კრედიტი - მასალები",
        "incorrect_answers": ["დებეტი - მასალები, კრედიტი - დაუმთავრებელი წარმოება", "დებეტი - დაუმთავრებელი წარმოება, კრედიტი - გასაცემი ხელფასი"],
        "unit": "5",
        "type": "theory"
    },
    {
        "question": "ინფორმაცია არის: ",
        "correct_answer": "გადამუშავებული მონაცემები, რომლის გამოყენება შეიძლება გადაწყვეტილებების მისაღებად",
        "incorrect_answers": ["სხვადასხვა მონაცემების ჯამი", "რიცხვები და სიმბოლოები"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "მონაცემები არის: ",
        "correct_answer": "ფაქტები, რიცხვები და სიმბოლოები მომხდარი მოვლენებისა და ოპერაციების შესახებ",
        "incorrect_answers": ["ინფორმაცია, რომლის გამოყენება შეიძლება გადაწყვეტილებების მისაღებად", "გადამუშვებული რიცხვები და სიმბოლოები"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "ფირმის მართვაში კოორდინაცია არის: ",
        "correct_answer": "ფირმის ყველა განყოფილების ჰარმონიული (შეთანხმებული) მუშაობის ორგანიზება",
        "incorrect_answers": ["საქმიანობის დაგეგმვა და კონტროლი", "ფაქტიური ინფორმაციის შედარება გეგმურ მაჩვენებელთნ"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "მმართელობითი აღრიცხვის მიზანია:  ",
        "correct_answer": "მოამზადოს ინფორმაცია შიდა მოხმარებისთვის: მენეჯერებისა და დირექტორებისთვის.",
        "incorrect_answers": ["ფირმის საქმიანობისთვის გადაწყვეტილების მიღება", "მოამზადოს ინფორმაცია გარე მომხმარებლებისთვის"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "რომელი მოსაზრებაა სწორი",
        "correct_answer": "საიმედო ინფორმაცია არის სასარგებლო მისი მიმღებისთვის",
        "incorrect_answers": ["საიმედო ინფორმაცია არის ყველაზე იაფი ინფორმაცია", "ინფორმაციის გადაცემა ყოველთვის ხდება ელექტრონული ფოსტით"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "საწარმოო პოლიტიკა არის: ",
        "correct_answer": "ჩამოყალიბებული დასკვნა (თეზისები), რომელიც წარმართავს გადაწყვეტილებების მიმღებთა აზროვნებას",
        "incorrect_answers": ["ფირმის განვითარების ტაქტიკური ღონისძიებები", "ფირმის განვითრების სტრატეგია"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "ფირმის ორგანიზაციული კონტროლი არის: ",
        "correct_answer": "საქმიანობის მონიტორინგი, ფაქტიური მდგომარეობის შეფასება, რაც უზრუნველყოფს რეაგირებას შედეგებზე",
        "incorrect_answers": ["დანახარჯების ზუსტი აღრიცხვის სისტემა", "ფირმის თითოეული განყოფილების საქმიანობის დაგეგმვა"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "ფირმის საქმიანობის დაგეგმვა არის: ",
        "correct_answer": "ფირმის სამეურნეო მიზნების ჩამოყალიბება და მათ მისაღწევად საჭირო სტრატეგიის, ტაქტიკის და მოქმედებების შერჩევა",
        "incorrect_answers": ["საწარმოო პოლიტიკის განსაზღვრა", "მონაცემების მიღება და დამუშავება"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "გადაწყვეტილების მიღება არის: ",
        "correct_answer": "რამდენიმე ალტერნატივიდან არჩევანის გაკეთება",
        "incorrect_answers": ["ფირმის განვითარების სტრატეგიის განსაზღვრა", "დანახარჯების გადახრების მიმოხილვა და გამოკვლევა"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "ფირმაში სტრატეგიული ინფორმაცია გამოიყენება: ",
        "correct_answer": "ფირმის საერთო მიზნების დაგეგმვისა და იმის შეფასებისთვის, მიღწეული იქნა თუ არა მიზნები",
        "incorrect_answers": ["ფირმის ცალკეული განყოფილების საქმიანობის კონტროლისთვის", "ფირმის ყოველდღიური ოპერაციების კონტროლისთვის"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "ტაქტიკური ინფორმაცია გამოიყენება: ",
        "correct_answer": "ფირმის ცალკეული განყოფილების საქმიანობის მართვისა და კონტროლისთვის",
        "incorrect_answers": ["ფირმის საერთო მიზნების დაგეგმვისა და კონტროლისთვის", "ფირმის ყოველდღიური ოპერაციების მართვისა და კონტროლისთვის"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "ფირმის ოპერაციული ინფორმაცია გამოიყენება: ",
        "correct_answer": "ყოველდღიური ოპერაციების მართვასა და კონტროლისთვის",
        "incorrect_answers": ["ფირმის ცალკეული განყოფილების საქმიანობის მართვისა და კონტროლისთვის", "ფირმის საერთო მიზნების დაგეგმვისა და კონტროლისთვის"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "მუშახელის დენედობის სტატისტიკა არის: ",
        "correct_answer": "ტაქტიკური ინფორმაცია",
        "incorrect_answers": ["ოპერატიული ინფორმაცია", "სტრატეგიული ინფორმაცია"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "ფირმის მოთხოვნა ფულად სახსრებზე არის:  ",
        "correct_answer": "სტრატეგიული ინფორმაცია",
        "incorrect_answers": ["ოპერატიული ინფორმაცია", "ტაქტიკური ინფორმაცია"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "'ენტონის სამკუთხედს' ასახავს:",
        "correct_answer": "სტრატეგიული, ტაქტიკური და ოპერატიული ინფორმაცია",
        "incorrect_answers": ["დაგეგმვის და კონტროლის ინფორმაცია", "დაგეგმვის, კონტროლისა და ანალიზის ინფორმაცია"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "მმართველობითი აღრიცხვის ინფორმაციის შდა წყაროებია: ",
        "correct_answer": "გაყიდვების მთავარი წიგნი, შესყიდვების მთავარი წიგნი, წარმოების დოკუმენტაცია",
        "incorrect_answers": ["გაყიდვების მთავარი წიგნი, წარმოების დოკუმენტაცია, მომხამრებელთა მოთხოვნები", "მონაცემები პოტენციურ მუშახელზე, ძირითადი საშუალების სისტემა, შესყიდვების მთავარი წიგნი"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "ფირმის ფინანსური მიზნებია",
        "correct_answer": "მომგებიანობა და გადახდისუნარიანობა",
        "incorrect_answers": ["პერსონალის ინტერესების დაკმაყოფილება და გარემოს დაცვა", "წარმოების ზრდა და გარემოს დაცვა"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "რომელი მოსაზრებაა სწორი",
        "correct_answer": "მმართველობითი აღრიცხვის ინფორმაციას ამზადებს არარეგულარულად, როცა  საჭიროა მენეჯმენტისათვის",
        "incorrect_answers": ["ფირმის მმართელობითი აღრიცხვის ინფორმაციის მომხამრებლებია საკრედიტო დაწესებულებები", "ფინანსური აღრიცხვის ინფორმაციის მომხმარებლებია წარმოების მენეჯერები"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "მოკლევადიან ტაქტიკურ გეგმას შეიძლება მიეკუთვნოს: ",
        "correct_answer": "პროდუქციის სარეალიზაციო ფასის შემცირება",
        "incorrect_answers": ["დანახარჯების გადახრების მიმოხილვა და ანალიზი", "მონიტორინგის განხორციელება ფაქტობრივ გაყიდვებზე"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "რომელი მოსაზრება ეხება საიმედო ინფორმაციის თვისებებს:  ",
        "correct_answer": "ორივე",
        "incorrect_answers": ["იგი გასაგები უნდა იყოს მიმღებისთვის", "ეხმარება მიმღებს სწორი გადაწყვეტილების მისაღებად"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "მმართველობითი აღრიცხვის ინფორმაცია არის: ",
        "correct_answer": "ფინანსური და არაფინანსური",
        "incorrect_answers": ["მხოლოდ ფინანსური", "მხოლოდ არაფინანსური"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "მმართველობითი აღრიცხვის ინფორმაციით ხდება: ",
        "correct_answer": "გადაწყვეტილებების მიღება, დაგეგმვა და კონტროლი",
        "incorrect_answers": ["შესყიდვები ჭურნალის წარმოება", "საოპერაციო დანახარჯების აღრიცხვა"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "ინფორმაცია ღირებულია როცა: ",
        "correct_answer": "გადაწყვეტილებების მიმღებთა მიერ, მოგების გაზრდის მიზნით",
        "incorrect_answers": ["მოპოვებულია იაფად", "გამოიყენება მისი მიმღების მიერ გამოიყენება"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "ინფორმაციას დანახარჯების მართვისა და კონტროლის მიზნით ამზადებს:  ",
        "correct_answer": "მმართველობითი აღრიცხვა",
        "incorrect_answers": ["მენეჯმენტი", "ფინანსური აღრიცხვა"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "მმართველობით აღრიცხვაში გამოიყენება თუ არა ორმაგი (ორადი) აღრიცხვის მეთოდი:  ",
        "correct_answer": "დიახ",
        "incorrect_answers": ["არა", "დაგეგმვის დროს"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "გადაწყვეტილების მიმღებთა აზროვნებას წარმართავს:  ",
        "correct_answer": "სხვადასხვა პოლიტიკა",
        "incorrect_answers": ["ღირებულებები", "სტრატეგიები"],
        "unit": "1",
        "type": "theory"
    },
    {
        "question": "რომელი მოსაზრებაა სწორი: ",
        "correct_answer": "დროითი ხელფასი მუშაკს ეძლევა ნამუშევარი დროის მიხედვით",
        "incorrect_answers": ["მუშაკს დროითი ხელფასი ეძლევა შესრულებული სამუშოების რაოდენობის მიხედვით", "სანარდო ხელფასი მუშკს ძლევა ნამუშევარი საათების მიხედვით"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "პირდაპირი შრომითი ხარჯი მოიცავს: ",
        "correct_answer": "პროდუქციის დამზადებაზე მომუშვე მუშების ხელფასს",
        "incorrect_answers": ["მანქანა-დანადგარების მეთვალყურე მუშების ხელფასს", "წარმოების მენეჯერების ხელფასს"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "ანაზღურებადია მოცდენილი საათები, რომელიც: ",
        "correct_answer": "გამოწვეულია საწარმოსაგან დამოუკიდებელი მიზეზებით",
        "incorrect_answers": ["გამოწვეულია მომუშავის მიზეზით", "გამოწვეულია შრომითი კანონმდებლობით"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "მოცდენილი საათების ანაზღაურება, რომლის თავიდან აცილება შეუძლებელი იყო, აღირიცხება როგორც: ",
        "correct_answer": "პირდაპირი ან არაპირდაპირი ხარჯი",
        "incorrect_answers": ["პირდაპირი ხარჯი", "არაპირდაპირი ხარჯი"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "მოცდენილი საათების ანაზღაურება, რომლის თავიდან აცილება შეიძლებოდა, დაეწერება:  ",
        "correct_answer": "მოგება/ზარალის ანგარიშს",
        "incorrect_answers": ["წარმოების ანგარიშს", "საწარმოო ზედნადების ხარჯების ანგარიშს"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "შრომითი კანონმდებლობით დადგენილი დასვენების დღეებით გამოწვეული მოცდენილი დროის ანაზღაურება ძირითადი მუშებისთვის, კლასიფიცირებულ უნდა იქნეს, როგორც:",
        "correct_answer": "პირდაპირი შრომითი ხარჯი",
        "incorrect_answers": ["არაპირდაპირი შრომითი ხარჯი", "საწარმოო ზედნადების ხარჯები"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "საწარმოს ხელმძღვანელი ადმინისტრაციული პერსონალის გარდაუვალი მოცდენების ანაზღურება კვალიფიცირებულ უნდა იქნეს, როგორც: ",
        "correct_answer": "პერიოდის ხარჯი",
        "incorrect_answers": ["პირდაპირი შრომითი ხარჯი", "არაპირდაპირი შრომითი ხარჯი"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "რომელი მოსაზრებაა სწორი: ",
        "correct_answer": "მოცდენა არის არაპროდუქტიული და ანაზღურებადი დრო",
        "incorrect_answers": ["მოცდენა არის ანაზღაურებადი და პროდუქტიული დრო", "მოცდენა არის არაპროდუქტიული და არაანაზღაურებადი დრო"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "მუშის ანაზღაურებადი დრო 520 საათია. მათ შორის, პროდუქტიული დრო 480 სთ. ხოლო ზენორმატიული დროში ნამუშევარია 50სთ. მოცდენილი დრო უდრის (საათი):",
        "correct_answer": "40",
        "incorrect_answers": ["90", "30"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "კომპანიაში ძირითდი მუშების მიერ ნამუშევარი პროდუქტიული დროა 9 200 სთ. მ.შ. ზენორმატიულ დროში ნამუშევარია 70 სთ, რაც გამოწვეული იყო ადრე არსებული მოცდენებით. საათობრივი ანაზღაურება 20 ლარია, ხოლო ზენორმატიული დრო ნაზღაურდება 1,5 განაკვეთით. მოახდინეთ ზენორმატიული დროის ანაზღაურების კლასიფიცირება: ",
        "correct_answer": "პერიოდის შრომითი ხარჯი 2 100 ლარი",
        "incorrect_answers": ["პირდაპირი შრომითი ხარჯი 1 400 ლარი და არაპირდაპირი შრომითი ხარჯი 2 100 ლარი", "პირდაპირი შრომითი ხარჯი 700 ლარი და შრომითი ხარჯი 1 400 ლარი"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "შემკვეთმა მოითხოვა შეკვეთის ვადაზე ადრე შესრულება, რის გამოც ზენორმატიულ დროში ნამუშევარია 710 სთ. საათობრივი ხელფასი 10 ლარია და ზენორმატიული დრო ნაზღაურდება 1,5 განაკვეთით. მოახდინეთ ზენორმატიული დროის ანაზღაურების კლასიფიცირება: ",
        "correct_answer": "პირდაპირი ხარჯი 10 650 ლარი",
        "incorrect_answers": ["პირდაპირი ხარჯი 7 100 ლ და არაპირდაპირი ხარჯი 3 550 ლარი", "არაპირდაპირი შრომითი ხარჯი 10 650 ლარი"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "კომპანიის მუშების გეგმური პროდუქტიული დროა 8 700სთ. ვარაუდობენ რომ მთლიანი დროის 10% მოცდენა იქნება. საათობრივი ხელფასი 6 ლარია. მთლიანი გეგმური დანახარჯები უდრის (ლარი)",
        "correct_answer": "58 002",
        "incorrect_answers": ["52 200", "46 980"],
        "unit": "6",
        "type": "tasj"
    },
    {
        "question": "ერთი ცალი პროდუქტის დასამზადებლად საჭიროა 2 სთ. ფაქტიურად გამოშვებულია 3600 ცალი პროდუქტი და დახარჯულია 6400 საათი. ნორმატიული საათების რა რაოდენობა დასჭირდებოდა ფაქტიურად გამოშვებულ პროდუქციას: ",
        "correct_answer": "7 200",
        "incorrect_answers": ["6 400", "8 000"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "მუშის წინა სამი თვის ხელფასი შესაბაისად, შეადგენდა 780, 805 და 800 ლარს. იგი გავიდა 29 დღიუან შვებულებაში. მუშის შევებულების ხელფასი იქნება (ლარი)",
        "correct_answer": "530",
        "incorrect_answers": ["636", "26,50"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "დამხმარე მუშის შვებულების ხელფასი შეიძლება კლასიფიცირებულ იქნეს, როგორც: ",
        "correct_answer": "არაპირდაპირი შრომითი ხარჯი",
        "incorrect_answers": ["პირდაპირი შრომითი ხარჯი", "პერიოდის ხარჯი"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "სამუშაოს შესრულებას 55 სთ სჭირდება. საათობრივი ანაზღაურება 10  ლარია. მუშამ სამუშაოს შესრულებას 49 სთ მოანდომა. პრემია ჰალსეის სისტემით უდრის (ლარი)",
        "correct_answer": "30",
        "incorrect_answers": ["60", "40"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "სამუშაოს შესრულებას 20 სთ სჭირდება. მუშამ მას 16 სთ მოანდომა. საათობრივი ანაზღაურება 12 ლარია. მუშის პრემია როუნის სისტემით იქნება (არის)",
        "correct_answer": "38,4",
        "incorrect_answers": ["19,2", "20,5"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "კომპანიის ხელმძღვანელობასა და პროფკავშირებს შორის შეთანხმების თანახმად, პროდუქციის გამოშვების გეგმის გადაჭარბების ყოველი პროცენტისთვის პრემიის კოეფიციენტია 3. მუშამ კვარტალური საწარმოო პროგრამა 102%-ით შეასრულა. მან კვარტლის განმავლობაში სულ 610 სთ იმუშავა. საათობრივი ხელფასი 10 ლარია. მუშაზე გასაცემი კვარტალური პრემია იქნება (ლარი): ",
        "correct_answer": "366",
        "incorrect_answers": ["230", "183"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "კომპანიაში წლის განმავლობაში სამუშაოდან 350 კაცი წავიდა. 320 თანამშრომელი შეიცვალა. დასაქმებულთა საშუალო სიობრივი რიცხვი შეადგენდა 2 500. მუშახელის დენადობის კოეფიციენტი პროცენტულად უდრის: ",
        "correct_answer": "12,8",
        "incorrect_answers": ["14", "10,5"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "მუშათა დენადობის კოეფიციენტი არის 0,11. სამუშაოდან წასულთა რიცხვი, რომელიც ახლით უნდა შეიცვალოს 120-ია. დასაქმებულთა რიცხვი იყო.",
        "correct_answer": "1 091",
        "incorrect_answers": ["950", "1 201"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "კომპანიაში მუშათა დენადობის კოეფიციენტია 0,125. დასაქმებულთა საშუალო რიცხვი 3 200. რამდენი თნამშრომელი წასულა კომპანიიდან, რომელიც ახლით შეიცვალა: ",
        "correct_answer": "400",
        "incorrect_answers": ["350", "300"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "კომპანიაში შრომისმწარმოებლურობა გამოითვლება ერთ საათში გამოშვებული პროდუქციის რაოდენობით. გეგმით ერთ საათში გამოშვებულ უნდა იქნეს 5 ცალი პროდუქტი. ფაქტიურად სულ გამოშვებულ იქნა 13 500 ცალი, რაზეც 2 500 სთ დაიხარჯა. რომელი მოსაზრებაა სწორი: ",
        "correct_answer": "ფაქტიური შრომისმწარმოებლურობა გეგმურთან შედარებით გაიზარდა. ",
        "incorrect_answers": ["ფაქტიური შრომისმწარმოებლურობა დაგეგმილთან შედარებით შემცირდა", "შრომისმოყვარეობის გეგმური დონე ფაქტიურად არ შეიცვალა"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "გაზრდილი საწარმოო გეგმის შესრულებული მიზნით საჭირო გახდა 80 სთ ზენორმატიული დრო, რომელიც გაორმაგებული განაკვეთით ანაზღურდება. საათობრივი ანაზღაურება 8 ლარია. არაპირდაპირი ხელფასი უდრის (ლარი)",
        "correct_answer": "640",
        "incorrect_answers": ["1 280", "500"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "ჩაის ფაბრიკამ დაიქირავა 45 საწარმოო მუშა ოთხი კვირით, 48 საათიანი სამუშო კვირისთვის. საწარმოო მოთხოვნიდან გამომდინარე, გამომუშავებული საათების საერთო რაოდენობა 12 600 სთ შეადგინა. ზენორმატიული დრი უდრის (სთ): ",
        "correct_answer": "3 960",
        "incorrect_answers": ["8 650", "4 500"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "შრომისმწარმოებლურობის მაჩვენებელი ახასიათებს: ",
        "correct_answer": "დროის ერთეულში გამოშვებული პროდუქციის რაოდენობას",
        "incorrect_answers": ["დანადგარების ერთეულზე გამოშვებაზე პროდუქციის რაოდენობას", "ნედლეულის გამოსავლიანობას"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "საწმოებაში ფაქტიურად დაიხარჯა 5 000 სთ, ხოლო შრომისმწარმოებლურობამ შეადგინა 3 ცალი/სთ. ფაქტიურად გამოშვებული პროდუქციის რაოდენობა უდრის (ცალი)",
        "correct_answer": "15 000",
        "incorrect_answers": ["12 000", "18 000"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "შრომისმწარმოებლურობის კოეფიციენტი ახასიათებს: ",
        "correct_answer": "შრომისმწარმოებლურობის ცვლილებისა გეგმურთნ შედარებით",
        "incorrect_answers": ["დროის ერთეულში გამოშვებული პროდუქციის რაოდენობას", "პროდუქციის ერთეულზე დახარჯული დროის რაოდენობას"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "ერთი ცალი პროდუქტის დამზადებას გეგმით 1,5 სთ სჭირდება. ფაქტიურად გამოშვებულია 4 600 ცალი პროდუქტი, რაზეც 7 350 სთ დაიხარჯა. რამდენი საათი დასჭირდებოდა ფაქტიურად გამოშვებულ პროდუქციას გეგმური დროის ნორმით: ",
        "correct_answer": "6 900",
        "incorrect_answers": ["4 900", "7 000"],
        "unit": "6",
        "type": "task"
    },
    {
        "question": "პირდაპირი ხელფასის დარიცხვა აღირიცხება: ",
        "correct_answer": "დებეტი - დაუმთავრებელი პროდუქცია; კრედიტი - გასაცემი ხელფასი",
        "incorrect_answers": ["დებეტი - დაუმთავრებელი პროდუქცია, კრედიტი - მოგება/ზარალი", "დებეტი - საწარმოო ზედნადები ხარჯები, კრედიტი - გასაცემი ხელფასი"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "მოცემული სიტუაციებიდან რომელი წარმოშობს მოცდენის დროს:  ",
        "correct_answer": "დაზიანდა მანქანა-დანადგარები და მუშები ელოდებიან დაასრულონ დაწყებული პროცესი",
        "incorrect_answers": ["მუშები მუშაობენ გეგმური შრომისმწარმოებლურობაზე დაბალი ნაყოფიერებით", "სამუშაოდან წავიდა რამდენიმე მუშა"],
        "unit": "6",
        "type": "theory"
    },
    {
        "question": "'ნორმატიული საათი' არის: ",
        "correct_answer": "ერთ საათში გამოსაშვები პროდუქციის გეგმური რაოდენობა",
        "incorrect_answers": ["ერთ სააში გამოშვებული პროდუქციის ფაქტიური რაოდენობა", "პროდუქციის ფაქტიური და გეგმური გამოშვების ფარდობა"],
        "unit": "6",
        "type": "theory"
    },
]